/**
 * @file useApiOptions.ts
 * @desc Hook for managing API options loading
 * @copyright All rights reserved @ Inarix
 */
import { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { ThunkDispatch } from "@reduxjs/toolkit";
import {
  fetchSBSites,
  fetchSBActionsNames,
} from "../../../redux/actions/users/userAsyncActions";
import { FilterItemExtended } from "../types";

interface UseApiOptionsProps {
  filterItems: FilterItemExtended[];
  columns: any[];
  locations: any[];
  actions: any[];
}

export const useApiOptions = ({
  filterItems,
  columns,
  locations,
  actions,
}: UseApiOptionsProps) => {
  const [apiOptions, setApiOptions] = useState<{ [key: number]: any[] }>({});
  const dispatch = useDispatch<ThunkDispatch<any, any, any>>();

  useEffect(() => {
    filterItems.forEach((item, index) => {
      if (item.field && item.operator === "$in") {
        const column = columns.find((col) => col.field === item.field);

        // Handle API filter for geoPoints (locations)
        if (column?.filter === "API" && column.service === "geoPoints") {
          if (
            !apiOptions[index] &&
            (!locations ||
              locations.length === 0 ||
              locations[0]?.id === undefined)
          ) {
            dispatch(fetchSBSites());
          } else if (
            locations &&
            locations.length > 0 &&
            locations[0]?.id !== undefined
          ) {
            setApiOptions((prev) => ({ ...prev, [index]: locations }));
          }
        }

        // Handle LOCAL filter for actions
        if (column?.filter === "LOCAL" && column.service === "actions") {
          if (
            !apiOptions[index] &&
            (!actions || actions.length === 0 || actions[0]?.id === undefined)
          ) {
            dispatch(fetchSBActionsNames());
          } else if (
            actions &&
            actions.length > 0 &&
            actions[0]?.id !== undefined
          ) {
            setApiOptions((prev) => ({ ...prev, [index]: actions }));
          }
        }
      }
    });
  }, [filterItems, columns, locations, actions, apiOptions, dispatch]);

  return { apiOptions };
};
